import {
  Component,
  ElementRef,
  AfterViewInit,
  effect,
  input,
  inject,
  DestroyRef,
} from '@angular/core';
import * as echarts from 'echarts';

@Component({
  selector: 'ui-chart',
  template: '',
  host: {
    class: 'block',
  },
})
export class ChartComponent implements AfterViewInit {
  private elementRef = inject(ElementRef);
  options = input.required<echarts.EChartsOption>();
  theme = input<'stromify-light' | 'stromify-dark'>();
  setOptionOpts = input<echarts.SetOptionOpts | boolean>();

  private chartInstance: echarts.ECharts | null = null;
  private resizeObserver: ResizeObserver | null = null;
  private destroyRef = inject(DestroyRef);

  constructor() {
    effect(() => {
      const currentOptions = this.options();
      if (this.chartInstance) {
        const opts = this.setOptionOpts();
        if (typeof opts === 'object') {
          this.chartInstance.setOption(currentOptions, opts);
        } else {
          this.chartInstance.setOption(currentOptions, opts ?? true);
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.initChart();
  }

  private initChart(): void {
    this.chartInstance = echarts.init(this.elementRef.nativeElement, this.theme());
    this.chartInstance.setOption(this.options());

    this.resizeObserver = new ResizeObserver(() => {
      this.chartInstance?.resize();
    });
    this.resizeObserver.observe(this.elementRef.nativeElement);

    this.destroyRef.onDestroy(() => {
      this.resizeObserver?.disconnect();
      this.chartInstance?.dispose();
      this.chartInstance = null;
    });
  }
}
